import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "@/features/auth/pages/protected-page";

export const Route = createFileRoute("/_authenticated/protected")({
  component: ProtectedPage,
});
